
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.781 5.281l1.438 1.438L7.938 13h13.063c3.845 0 7 3.155 7 7v7h-2v-7c0-2.755-2.245-5-5-5H7.938l6.281 6.281-1.438 1.438-8-8L4.093 14l.688-.719z"}})])
          )
        }
      }
    